import Modal from './Modal';
import ModalContent from './ModalContent';
import ModalFooter from './ModalFooter';

export { Modal, ModalContent, ModalFooter };
export default Modal;
